import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { navigation, profile } from "../../data/site";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event) => {
      if (event.key === "Escape") setOpen(false);
    };
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <header
      className="site-nav fixed inset-x-0 top-0 z-50 border-b backdrop-blur-md"
      style={{
        background: "var(--nav)",
        borderColor: scrolled || open ? "var(--line)" : "transparent",
      }}
    >
      <div className="mx-auto flex h-[4.25rem] w-full max-w-site items-center justify-between px-5 sm:px-8">
        <NavLink to="/" end className="nav-brand text-[0.95rem] font-medium tracking-tight text-[var(--ink)]">
          {profile.name}
        </NavLink>

        <nav className="hidden items-center gap-6 xl:flex" aria-label="Primary">
          {navigation.map((item) => (
            <NavLink
              key={item.href}
              to={item.href}
              end={item.href === "/"}
              className={({ isActive }) => `nav-link ${isActive ? "nav-link-active" : ""}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <button
          type="button"
          className="inline-flex h-11 items-center px-1 text-sm font-medium text-[var(--ink)] xl:hidden"
          aria-expanded={open}
          aria-controls="mobile-navigation"
          onClick={() => setOpen((value) => !value)}
        >
          {open ? "Close" : "Menu"}
        </button>
      </div>

      {open ? (
        <nav
          id="mobile-navigation"
          aria-label="Primary"
          className="border-t border-[var(--line)] bg-[var(--bg)] xl:hidden"
        >
          <div className="mx-auto flex max-h-[calc(100svh-4.25rem)] w-full max-w-site flex-col overflow-y-auto px-5 py-2 sm:px-8">
            {navigation.map((item) => (
              <NavLink
                key={item.href}
                to={item.href}
                end={item.href === "/"}
                className={({ isActive }) =>
                  `mobile-nav-link border-b border-[var(--line)] px-2 py-4 text-lg last:border-b-0 ${
                    isActive ? "mobile-nav-link-active" : ""
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </nav>
      ) : null}
    </header>
  );
}
